import fetch from './fetch';
import EndPoints from '../data/EndPoints';
import Methods from '../data/Methods';

export default (companyId, invoiceId) => {
	const headers = { 'content-type': 'application/json' };
	return fetch(
		Methods.POST,
		EndPoints.COMPANIES_INVOICE_CONCEPT_ID_TOGGLE_PAID.replace(':id', companyId).replace(
			':invoiceconceptid',
			invoiceId
		),
		null,
		headers,
		true
	);
};
